import { ChangeDetectionStrategy, Component, OnInit, OnDestroy } from '@angular/core';
import { ModalSizes, MotifModal } from '@ey-xd/ng-motif';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/modules/authentication/authentication.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'session-warning-modal-content',
  templateUrl: './session-expiry-warning.component.html',
  styleUrls: ['./session-expiry-warning.component.scss']
})
export class SessionExpiryWarningModal implements OnInit, OnDestroy {
  private subscription!: Subscription;
  public sessionRemainingTime!: number;
  constructor(public modal: MotifModal, private authService: AuthenticationService ) { }
  
  ngOnInit(): void {
    this.subscription = this.authService.activeSessionRemainingTime.subscribe(
      time => {
        if(time !== undefined){
          this.sessionRemainingTime = time
        }
      })
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  renewSession() {
    this.subscription = this.authService.renewActiveSession().subscribe(res => {
      if (res && this.modal.getModalById('session-expiry-warning-modal')) {
        this.modal.getModalById('session-expiry-warning-modal')?.close()
      }
    })
  }
}


@Component({
  selector: 'app-session-expiry-warning',
  template: '',
})
export class SessionExpiryWarningComponent implements OnInit, OnDestroy {
  private subscription!: Subscription;
  constructor(
    public modal: MotifModal,
    private authService: AuthenticationService
    ) { }

  ngOnInit(): void {
    this.subscription = this.authService.activeSessionRemainingTime.subscribe(
      time => {
        if (time && time === environment.authConfig.activeSessionTimeOutWarningInSeconds){
          this.openModalWarning();
        }
        if (time == 0){
          this.closeModelWarning();
        }
    })
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  closeModelWarning() {
    this.modal.getModalById('session-expiry-warning-modal')?.close();
  }
  openModalWarning() {
    this.modal.open(SessionExpiryWarningModal, {
      id: 'session-expiry-warning-modal',
    });
  }
}


